// extracted by mini-css-extract-plugin
var _1 = "button--iuEFw";
var _2 = "container--YJGW_";
var _3 = "content--wZcHv";
var _4 = "errorBox--xujgp";
var _5 = "message--hPDKr";
var _6 = "title--YYyYg";
export { _1 as "button", _2 as "container", _3 as "content", _4 as "errorBox", _5 as "message", _6 as "title" }
